import {NgModule} from '@angular/core';
import {MomentDatePipe} from './moment-date.pipe';
import {ReplaceLineBreaks} from './replace-line-breaks.pipe';
import { CostPipe } from './cost.pipe';

@NgModule({
  imports: [],
  declarations: [
    MomentDatePipe,
    ReplaceLineBreaks,
    CostPipe
  ],
  exports: [
    MomentDatePipe,
    ReplaceLineBreaks,
    CostPipe
  ]
})

export class PipesModule {
}
